import React from "react";
import { getDaysUntilExpiry } from "../../utils/helpers";

import { Badge, Button } from "react-bootstrap";
import {
  FaFileAlt,
  FaFileWord,
  FaFilePdf,
  FaFileImage,
  FaFile,
  FaClock,
  FaCalendarAlt,
  FaEye,
  FaDownload,
} from "react-icons/fa";
import { useAuth } from "../../hooks/useAuth";
function DocumentsTab({ documents = [] }) {
  const { backendUrl } = useAuth();
  const getDocTypeVariant = (type) => {
    const variants = {
      license: "primary",
      registration: "success",
      insurance: "warning",
      inspection: "info",
      contract: "secondary",
      receipt: "dark",
      invoice: "danger",
      photo: "light",
      manual: "info",
      other: "secondary",
    };
    return variants[type] || "secondary";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // Get icon based on mime type
  const getFileIcon = (mimeType) => {
    if (mimeType.includes("pdf"))
      return <FaFilePdf className="file-icon pdf" />;
    if (mimeType.includes("word") || mimeType.includes("document"))
      return <FaFileWord className="file-icon word" />;
    if (mimeType.includes("image"))
      return <FaFileImage className="file-icon image" />;
    return <FaFile className="file-icon default" />;
  };

  // Format file size
  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
    return (bytes / (1024 * 1024)).toFixed(1) + " MB";
  };

  return (
    <div className="documents-section">
      <div className="documents-grid">
        {documents.map((doc) => {
          const daysUntilExpiry = getDaysUntilExpiry(doc.expiryDate);
          const isExpiringSoon =
            daysUntilExpiry !== null &&
            daysUntilExpiry <= 30 &&
            daysUntilExpiry > 0;

          return (
            <div key={doc.document_id} className="document-card">
              <div className="document-card-header">
                <div className="document-icon-wrapper">
                  {getFileIcon(doc.mimeType)}
                </div>
                <Badge
                  bg={getDocTypeVariant(doc.documentType)}
                  className="doc-type-badge"
                >
                  {doc.documentType}
                </Badge>
              </div>

              <div className="document-card-body">
                <h6 className="document-title" title={doc.title}>
                  {doc.title}
                </h6>

                {doc.description && (
                  <p className="document-description" title={doc.description}>
                    {doc.description}
                  </p>
                )}

                <div className="document-filename">
                  <FaFileAlt className="me-1" size={12} />
                  <span title={doc.originalFileName}>
                    {doc.originalFileName}
                  </span>
                </div>

                <div className="document-meta">
                  <span className="file-size">
                    {formatFileSize(doc.fileSize)}
                  </span>
                  <span className="upload-date">
                    <FaClock className="me-1" size={10} />
                    {formatDate(doc.createdAt)}
                  </span>
                </div>

                {doc.expiryDate && (
                  <div
                    className={`expiry-section ${
                      doc.isExpired ? "expired" : ""
                    } ${isExpiringSoon ? "expiring-soon" : ""}`}
                  >
                    <FaCalendarAlt className="me-1" size={12} />
                    <span className="expiry-label">
                      {doc.isExpired ? "Expired: " : "Expires: "}
                    </span>
                    <span className="expiry-date">
                      {formatDate(doc.expiryDate)}
                    </span>
                    {doc.isExpired && (
                      <Badge bg="danger" className="ms-2">
                        Expired
                      </Badge>
                    )}
                    {isExpiringSoon && !doc.isExpired && (
                      <Badge bg="warning" className="ms-2">
                        {daysUntilExpiry} days left
                      </Badge>
                    )}
                  </div>
                )}
              </div>

              <div className="document-card-footer">
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() =>
                    window.open(`${backendUrl}/static${doc.filePath}`, "_blank")
                  }
                >
                  <FaEye className="me-1" /> View
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => {
                    const link = document.createElement("a");
                    link.href = `${backendUrl}/static${doc.filePath}`;
                    link.download = doc.originalFileName;
                    link.click();
                  }}
                >
                  <FaDownload className="me-1" /> Download
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default DocumentsTab;
